import { classNames as cn } from 'helpers';
import arionStar from 'img/arion-star.svg';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';

export function LoadingScreen() {
	const { state, t } = useContext(AppContext);
	return (
		<div className={cn('loading', { hidden: state.loading.loading < 1 })}>
			<div className="container">
				<div className="row">
					<div className="col-12 col-sm-2">
						<img alt="" className="d-flex" src={arionStar} />
					</div>
					<div className="col-12 col-sm-10 pt-1">
						<p>{state.loading.message || t('loading')}</p>
						<div className="loading-indicator" />
					</div>
				</div>
			</div>
		</div>
	);
}
